// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"ef089c52","276":"cf4d5623","404":"ae9728bd","498":"d10fba82","510":"940410c1","513":"53d13db0","602":"57ee11d8","611":"d4fd78bc","661":"42161b93"}[chunkId] + ".chunk.js";
};